export default __webpack_public_path__ + "static/Крысиные бега_17-93290436db0f27bc4e074cbe5717a2e2.jpg";